'use client';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { MenuItemContainer, MenuItemContent } from './Menu.styles.js';
import { MENU_ITEM_SIZE, DEFAULT_VARIANT } from './Menu.constants.js';
import { SURFACE_VARIANT_KEYS } from '../../constants/variants.js';

var MenuItem = function MenuItem(_ref) {
  var children = _ref.children,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'li' : _ref$component,
    _ref$componentProps = _ref.componentProps,
    componentProps = _ref$componentProps === void 0 ? {} : _ref$componentProps,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? undefined : _ref$iconPosition,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    _ref$isTitle = _ref.isTitle,
    isTitle = _ref$isTitle === void 0 ? false : _ref$isTitle,
    _ref$isOpaque = _ref.isOpaque,
    isOpaque = _ref$isOpaque === void 0 ? false : _ref$isOpaque,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? undefined : _ref$onKeyDown,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? MENU_ITEM_SIZE.SMALL : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? DEFAULT_VARIANT : _ref$variant;
  return React__default.createElement(MenuItemContainer, _extends({
    as: component
  }, componentProps, {
    $isActive: isActive,
    onClick: disabled ? undefined : onClick,
    $isDisabled: disabled,
    "data-testid": testId,
    onKeyDown: onKeyDown,
    $isTitle: isTitle,
    role: "menuitem",
    "aria-disabled": disabled,
    $isOpaque: isOpaque,
    $variant: variant,
    tabIndex: 0
  }), React__default.createElement(MenuItemContent, {
    $isActive: isActive,
    $variant: variant,
    $size: size,
    $iconPosition: iconPosition
  }, children));
};
MenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  componentProps: PropTypes.object,
  disabled: PropTypes.bool,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  isActive: PropTypes.bool,
  isOpaque: PropTypes.bool,
  isTitle: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  size: PropTypes.oneOf(Object.values(MENU_ITEM_SIZE)),
  testId: PropTypes.string,
  variant: PropTypes.oneOf(SURFACE_VARIANT_KEYS)
};

export { MenuItem, MenuItem as default };
//# sourceMappingURL=MenuItem.js.map
